module.exports = __webpack_public_path__ + "media/images/1-01-86c400aa8caaebbd1f157fb931ed1c29.svg";